import axios from "../http";

class DataState {
  getDataState(warehouseId) {
    const url = `/zwy/api/data/info?warehouseId=${warehouseId}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  getDataPublish(warehouseId, date) {
    const url = `/zwy/api/data/publish?warehouseId=${warehouseId}&date=${date}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //看板数据
  getScreenData() {
    const url = `/zwy/api/data/board`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default DataState;
